import { reviewPages, type ReviewSlug } from "@/data/serviceReviews";
import { serviceFaqs } from "@/data/serviceFaqs";
import { canonicalLinks, ogUrl, ogImage, jsonLd, serviceSchema, breadcrumbSchema, faqPageSchema, webPageSchema, absoluteUrl } from "./seo";
export function serviceReviewHead(slug: ReviewSlug) {
  const p=reviewPages[slug], path=`/services/${slug}`, id=`${absoluteUrl(path)}#service`;
  return {
    meta: [{ title:p.title }, { name:"description",content:p.description }, { property:"og:title",content:p.title }, { property:"og:description",content:p.description }, { property:"og:type",content:"website" }, { name:"twitter:card",content:"summary_large_image" }, ...ogImage(`services-${slug}`, `${p.name} by Ajility`), ogUrl(path)],
    links:canonicalLinks(path),
    scripts:[
      jsonLd({...webPageSchema({path,name:p.title,description:p.description,mainEntityId:id}), speakable:{"@type":"SpeakableSpecification",cssSelector:["#in-short"]}}),
      jsonLd({...serviceSchema({name:p.name,description:p.short,path,slug,serviceType:"Business consulting"}), audience:{"@type":"BusinessAudience",name:"Owner-led businesses, $3M to $30M annual turnover"}}),
      jsonLd(breadcrumbSchema([{name:"Services",path:"/services"},{name:p.name,path}])),
      jsonLd(faqPageSchema(path,serviceFaqs[slug],id)),
    ],
  };
}
